import { createFileRoute } from "@tanstack/react-router";
import { listingPageApiRoute } from "@/features/listings";

export const Route = createFileRoute("/api/v1/listings/$listingId/page")({
    ...listingPageApiRoute,
});
